﻿class Checkbox {
  constructor() {

  }
  init() {
    const wrappers = document.querySelectorAll(".checkbox");
    wrappers.forEach(wrapper => {
      const input = wrapper.querySelector('input');
      input.addEventListener('change', function(e) {
        wrapper.setAttribute('data-checked', e.target.checked);
      });
    });
  }
}

export default new Checkbox();